const Branch = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 14.5V10q0-.021-.002-.041a3 3 0 1 0-.996 0L7.5 10v10a.5.5 0 0 0 1 0v-4.5H14a2.5 2.5 0 0 0 2.5-2.5v-3l-.002-.041a3 3 0 1 0-.996 0L15.5 10v3a1.5 1.5 0 0 1-1.5 1.5zM16 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      clipRule="evenodd"
    />
  </>
)
export default Branch
